import { Component, OnInit, ViewChild } from '@angular/core';
import { TelemarketingService } from './services/telemarketing.service';
import { Telemarketing } from './interfaces/telemarketing.interface';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-telemarketing',
  templateUrl: './telemarketing.component.html',
  providers: [MessageService]
})
export class TelemarketingComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  
  dataSource: Telemarketing[] = [];
  loading: boolean = true;
  displayDialog: boolean = false;
  selectedTelemarketing: Telemarketing | null = null;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'cvetelefonista', header: 'Clave' },
    { field: 'nombre', header: 'Nombres' },
    { field: 'numeroempleado', header: 'N° Empleado' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private telemarketingService: TelemarketingService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.telemarketingService.getTelemarketing().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar datos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos'
        });
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  openCreate(): void {
    this.selectedTelemarketing = null;
    this.displayDialog = true;
  }

  openUpdate(telemarketing: Telemarketing): void {
    this.loading = true;
    this.telemarketingService.getTelemarketingDetails(telemarketing.cvetelefonista).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          this.selectedTelemarketing = response.data[0];
          this.displayDialog = true;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los detalles del telemarketer'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar detalles:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los detalles del telemarketer'
        });
        this.loading = false;
      }
    });
  }

  openDelete(telemarketing: Telemarketing): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este telemarketer?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.telemarketingService.deleteTelemarketing(telemarketing.cvetelefonista).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Telemarketer eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el telemarketer'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el telemarketer'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedTelemarketing = null;
    this.displayDialog = false;
  }

  onSave(event: { success: boolean; message: string }): void {
    if (event.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }
} 